import React, { FC } from 'react'
import FilterConnector, { ConnectorProps as FilterConnectorProps } from '../../connectors/Filter'
import FilterIcon from 'svg/filter-v2.svg'
import styles from './HeaderComponents.module.scss'
import Skeleton from 'components/SA/Skeleton'
import useIsMobile from 'hooks/useIsMobile'
import useAvoidLayoutShift from 'hooks/useAvoidLayoutShift'
import useQA from 'hooks/useQA'

type FilterButtonProps = FilterConnectorProps & {
  isFiltersVisible?: boolean
  onClickFilterButton: () => void
}

const FilterButton: FC<FilterButtonProps> = ({
  isFiltersVisible,
  facetCount,
  onClickFilterButton,
}) => {
  const { isSkeletonVisible } = useAvoidLayoutShift()
  const isMobileScreen = useIsMobile()
  const { testId } = useQA()

  return isSkeletonVisible ? (
    <Skeleton width='200px' height='46px' />
  ) : (
    <button
      className={styles.filterButton}
      onClick={onClickFilterButton}
      {...testId('filter-button')}
    >
      <FilterIcon />
      <span>
        {!isFiltersVisible || isMobileScreen ? 'Filters' : 'Hide Filters'}{' '}
        {facetCount ? ` (${facetCount})` : ``}
      </span>
    </button>
  )
}

export default FilterConnector(FilterButton)
